import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notifyUser } from "components/shared-components/AdvancareNotification";
import QandAService from "services/QandAService";

export const initialState = {
  list: [],
  loading: false,
  transfering: false,
  transferingDone: false,
  confirming: false,
  confirmingDone: false,
  sendingCustomerCommunicationWithComplainOfficer: false,
  sendingCustomerCommunicationWithComplainOfficerDone: false,
  satisfactionList: [],
  satisfactionLoading: false,
  satisfactionSentSuccessfully: false,
  complainingSentSuccessfully: false,
  complainingLoading: false,
};

export const fetchQandAReport = createAsyncThunk(
  "/fetchQandAReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await QandAService.fetchQandAReport(payload);
      const code = response.code;
      return {
        code: code,
        data: response.result.complainingList,
        satisfactionList: response.result.satisfactionList,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const saveSatisfactionSurvery = createAsyncThunk(
  "/saveSatisfactionSurvery",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await QandAService.saveSatisfactionSurvery(payload);
      const code = response.code;
      return {
        code: code,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const saveComplainingSurvery = createAsyncThunk(
  "/saveComplainingSurvery",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await QandAService.saveComplainingSurvery(payload);
      const code = response.code;
      return {
        code: code,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const transferSatisfactionSurveryToWhomItMayConcern = createAsyncThunk(
  "/transferSatisfactionSurveryToWhomItMayConcern",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await QandAService.transferSatisfactionSurveryToWhomItMayConcern(
          payload
        );
      const code = response.code;
      return {
        code: code,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const saveCustomerCommunicationWithComplainOfficer = createAsyncThunk(
  "/saveCustomerCommunicationWithComplainOfficer",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await QandAService.sendCustomerCommunicationWithComplainOfficer(
          payload
        );
      const code = response.code;
      return {
        code: code,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);

export const confirmComplainOfficerMessage = createAsyncThunk(
  "/confirmComplainOfficerMessage",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await QandAService.confirmComplainOfficerMessage(payload);
      const code = response.code;
      return {
        code: code,
        data: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Something went wrong",
        }
      );
    }
  }
);
export const customerSatsfactionAndComplainingSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    showLoading: (state, action) => {
      state.loading = !state.loading;
    },
    resetSatisfactionSentSuccessfully: (state, action) => {
      state.satisfactionSentSuccessfully = false;
    },
    resetComplainingSentSuccessfully: (state, action) => {
      state.complainingSentSuccessfully = false;
    },
    resetTransferingDone: (state, action) => {
      state.transferingDone = false;
    },
    resetCustomerCommunicationWithComplainOfficer: (state, action) => {
      state.sendingCustomerCommunicationWithComplainOfficerDone = false;
    },
    resetConfirmingDone: (state, action) => {
      state.confirmingDone = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQandAReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQandAReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.satisfactionList = action.payload.satisfactionList;
      })
      .addCase(fetchQandAReport.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
      })
      .addCase(saveSatisfactionSurvery.pending, (state) => {
        state.satisfactionLoading = true;
      })
      .addCase(saveSatisfactionSurvery.fulfilled, (state, action) => {
        state.satisfactionLoading = false;
        state.satisfactionSentSuccessfully = true;
      })
      .addCase(saveSatisfactionSurvery.rejected, (state, action) => {
        state.satisfactionLoading = false;
        notifyUser(
          "error",
          "bottomRight",
          "Error occurred while submitting the complaint / ቅሬታዎ ላይ ስህተት አጋጥሟል"
        );
      })
      .addCase(saveComplainingSurvery.pending, (state) => {
        state.complainingLoading = true;
      })
      .addCase(saveComplainingSurvery.fulfilled, (state, action) => {
        state.complainingLoading = false;
        state.complainingSentSuccessfully = true;
      })
      .addCase(saveComplainingSurvery.rejected, (state, action) => {
        state.complainingLoading = false;
        notifyUser(
          "error",
          "bottomRight",
          "Error occurred while submitting the complaint / ቅሬታዎ ላይ ስህተት አጋጥሟል"
        );
      })
      .addCase(
        transferSatisfactionSurveryToWhomItMayConcern.pending,
        (state) => {
          state.transfering = true;
        }
      )
      .addCase(
        transferSatisfactionSurveryToWhomItMayConcern.fulfilled,
        (state, action) => {
          state.transfering = false;
          state.transferingDone = true;
        }
      )
      .addCase(
        transferSatisfactionSurveryToWhomItMayConcern.rejected,
        (state, action) => {
          state.transfering = false;
          notifyUser(
            "error",
            "bottomRight",
            "Error occurred while transferring the complaint"
          );
        }
      )
      .addCase(
        saveCustomerCommunicationWithComplainOfficer.pending,
        (state) => {
          state.sendingCustomerCommunicationWithComplainOfficer = true;
        }
      )
      .addCase(
        saveCustomerCommunicationWithComplainOfficer.fulfilled,
        (state, action) => {
          state.sendingCustomerCommunicationWithComplainOfficer = false;
          state.sendingCustomerCommunicationWithComplainOfficerDone = true;
        }
      )
      .addCase(
        saveCustomerCommunicationWithComplainOfficer.rejected,
        (state, action) => {
          state.sendingCustomerCommunicationWithComplainOfficer = false;
          notifyUser("error", "bottomRight", "Something went wrong");
        }
      )
      .addCase(confirmComplainOfficerMessage.pending, (state) => {
        state.confirming = true;
      })
      .addCase(confirmComplainOfficerMessage.fulfilled, (state, action) => {
        state.confirming = false;
        state.confirmingDone = true;
      })
      .addCase(confirmComplainOfficerMessage.rejected, (state, action) => {
        state.confirming = false;
        notifyUser("error", "bottomRight", "Something went wrong");
      });
  },
});

export const {
  showLoading,
  resetComplainingSentSuccessfully,
  resetSatisfactionSentSuccessfully,
  resetTransferingDone,
  resetCustomerCommunicationWithComplainOfficer,
  resetConfirmingDone,
} = customerSatsfactionAndComplainingSlice.actions;

export default customerSatsfactionAndComplainingSlice.reducer;
